var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitterGradient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.762 2.583c-.78.346-1.63.594-2.505.691A4.432 4.432 0 0021.17.814a8.457 8.457 0 01-2.76 1.079A4.341 4.341 0 0016.965.848a4.246 4.246 0 00-1.733-.366c-2.41 0-4.349 2.005-4.349 4.464 0 .346.041.691.107 1.023-3.61-.193-6.828-1.962-8.968-4.67a4.518 4.518 0 00-.592 2.253c0 1.549.768 2.914 1.938 3.718a4.304 4.304 0 01-1.966-.568v.055c0 2.169 1.495 3.966 3.487 4.38a4.5 4.5 0 01-1.146.152c-.283 0-.55-.03-.82-.068.55 1.768 2.155 3.053 4.065 3.095a8.58 8.58 0 01-5.4 1.907c-.365 0-.701-.013-1.05-.055a12.093 12.093 0 006.68 2.002c7.999 0 12.376-6.798 12.376-12.698 0-.194 0-.387-.013-.58a9.504 9.504 0 002.181-2.309z",
    fill: "url(#twitter-gradient_svg__paint0_linear_1924_26442)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "twitter-gradient_svg__paint0_linear_1924_26442",
    x1: 12.398,
    y1: 33.701,
    x2: 28.44,
    y2: 25.275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#01D6B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#218FEE"
  })))));
}

export default SvgTwitterGradient;